import request from '@/util/http'

/**
 * Guest - 游客快速注册并保存地址
 */
export function guestRegister(data) {
  return request({
    url: '/upms/shop/guest/register',
    method: 'post',
    data: data,
  })
}

/**
 * Guest - 检查邮箱是否已注册
 */
export function checkEmail(params) {
  return request({
    url: '/upms/shop/guest/check_email',
    method: 'get',
    params: params,
  })
}

/**
 * Guest - 查询游客下单功能是否开启
 */
export function getGuestCheckoutEnabled() {
  return request({
    url: '/upms/shop/guest/guest_checkout_enabled',
    method: 'get',
  })
}

/**
 * Guest - 发送邮箱验证码
 */
export function sendVerifyCode(data) {
  return request({
    url: '/upms/shop/guest/send_verify_code',
    method: 'post',
    data: data,
  })
}

/**
 * Guest - 通过验证码重置密码
 */
export function resetPassword(data) {
  return request({
    url: '/upms/shop/guest/reset_password',
    method: 'post',
    data: data,
  })
}
